// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"DefaultSession_Wrapper__24dER","DateText":"DefaultSession_DateText__1MJC-","TimeText":"DefaultSession_TimeText__3DvTT"};